/*
================================================================ 
     Copyright (c) 2018-2021 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import classes from "./catalog.module.css";
import { Link } from "react-router-dom";
import constants from "../../../helper/constants";
import { connect } from "react-redux";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import draftStatus from "../../../asset/images/draftStatus.png";
import reviewStatus from "../../../asset/images/reviewStatus.png";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import { withTranslation } from "react-i18next";

import Badge from "@mui/material/Badge";
import { green, red } from "@mui/material/colors";
import LockIcon from "@mui/icons-material/Lock";
import DraftsIcon from "@mui/icons-material/Drafts";
import PublicIcon from "@mui/icons-material/Public";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import currencyFormatter from "../../../helper/currencyFormatter";
import { DefaultImage } from "../../../helper/setFallbackImages";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "../../../component/button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";
// import Button from '@mui/material/Button';

import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Chip from "@mui/material/Chip";
import {
  DeleteIconNew,
  EditIconNew,
  EditSpecialPrice,
  ExportIcon,
  ViewIconNew,
  CartIcon,
} from "../../../component/icons/icons";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Draggable from "react-draggable";
import BusApiCall from "../../../helper/axios";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Loader from "../../../component/loader";
// import { makeStyles } from '@mui/styles';
import { useNavigate, useLocation } from "react-router-dom";

const ProductCardNew = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const location = useLocation();
  // console.log('props.producvt===', props)
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [pushOfferingDialog, setPushOfferingDialog] = useState(false);
  const [childTenantsList, setChildTenantsList] = useState([]);
  const [selectedTenants, setSelectedTenants] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // const useStyles = makeStyles({
  // 	resizablePaper: {
  // 		resize: 'both',
  // 		overflow: 'auto',
  // 		minWidth: 640,
  // 		minHeight: 200,
  // 		maxWidth: '90vw',
  // 		maxHeight: '90vh',
  // 		width: '60vw',
  // 	}
  // });
  // const classess = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };
  // console.log('props.product', {imageUrl: constants.imageUrl + props.product.largeImageUrl,
  // 	image: props.product.largeImageUrl
  // });
  const handleClose = () => {
    setOpen(false);
  };
  // console.log('props.product', props.solutionAction, props.product.statusDisplayName)

  const handlePushOffering = () => {
    setPushOfferingDialog(true);
    getChildTenantsList();
  };
  const getChildTenantsList = () => {
    setIsLoading(true);
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
    )
      .then((res) => {
        let data = res.data;
        if (data.tenants && data.tenants.length > 0) {
          setChildTenantsList(data.tenants);
        } else {
          setChildTenantsList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleTenantSelection = (tenantId) => {
    setSelectedTenants((prev) => {
      if (prev.includes(tenantId)) {
        return prev.filter((id) => id !== tenantId);
      }
      return [...prev, tenantId];
    });
  };
  const toDataUrl = (url) => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };
  const pushOfferingToTenants = async (tenantIds) => {
    setIsLoading(true);
    const imageFilename = props.product.largeImageUrl?.split("/").pop() || "";
    const base64Image = await toDataUrl(
      constants.imageUrl + props.product.largeImageUrl,
    );
    var payload = {
      tenantIds: tenantIds,
      packageId: props.product.productOfferingId,
      productMainImage: imageFilename,
      productMainImageSource: base64Image,
    };
    BusApiCall("POST", `${constants.busInternalUrl}/packagedSolutions`, payload)
      .then((res) => {
        console.log("res", res);
        props.setErrorMessage(t("PUSH_OFFERING_SUCCESS"), true);
      })
      .catch((err) => {
        console.log("err", err);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(t("DEFAULT_ERROR_MESSAGE"), false);
        }
      })
      .finally(() => {
        setIsLoading(false);
        setPushOfferingDialog(false);
        setSelectedTenants([]);
        setChildTenantsList([]);
      });
  };
  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  const id = open ? "simple-popper" : undefined;
  return (
    <Grid
      item
      size={{
        xs: 12,
        sm: 4,
        md: 3,
      }}
    >
      <Card variant="outlined" className={classes.cardNew}>
        {props.solutionAction !== "/newOrder" &&
          props.solutionAction !== "/product" ? (
          <>
            <Link
              to={
                props.providerType === "SALES_CHNL_PROVIDER"
                  ? props.solutionAction === "/myOfferings"
                    ? `/viewProduct/${props.product.productId}?type=myOfferings`
                    : props.solutionAction === "/product" ||
                      props.solutionAction === "/newOrder"
                      ? `/viewProduct/${props.product.productOfferingId}?type=myOfferings`
                      : `/viewProduct/${props.product.productId}?type=availableOfferings`
                  : props.solutionAction === "/product" ||
                    props.solutionAction === "/newOrder"
                    ? `/product/${props.product.productOfferingId}`
                    : `/product/${props.product.productId}`
              }
            >
              <div className={classes.imageContainer}>
                <div className={classes.imageWrapper}>
                  {/* <CardMedia
										component="img"
										alt={props.product.name}
										height="140"
										image={props.product.largeImageUrl ? constants.imageUrl + props.product.largeImageUrl : placeholderImage}
										title={props.product.name}
										onError={DefaultImage}
										className={classes.cardImageNew}
									/> */}
                  <div
                    className="product-card-image-wrapper"
                    style={{
                      backgroundImage: props.product.largeImageUrl
                        ? `url(${constants.imageUrl + props.product.largeImageUrl})`
                        : `url(${placeholderImage})`,
                    }}
                  >
                    {/* <img src={props.product.largeImageUrl ? constants.imageUrl + props.product.largeImageUrl : placeholderImage}
											alt={props.product.name}
										/> */}
                  </div>
                  <div className={classes.chipWrapper}>
                    {/* {props.solutionAction === "/myOfferings" || props.solutionAction === "/availableOfferings" ? (
											props.product.isSubmittedForReview ? (
												props.userPerms.includes("CUMULATOR_PRODUCT_COMMIT") ? (
													<Chip size="normal" style={{ background: "#ffefcc", color: "#a78025", fontWeight: "600" }} label={t("PENDING_REVIEW")} />
												) : (
													<Chip size="normal" style={{ background: "#ffefcc", color: "#a78025", fontWeight: "600" }} label={t("PENDING_REVIEW")} />
												)
											) : !props.product.isApproved ? (
												<Chip
													size="normal"
													style={{ background: "#ffefcc", color: "#a78025", fontWeight: "600" }}
													label={t("APPROVE_ALERT_TEXT")}
												/>
											) : (
												<Chip size="normal" style={{ background: "#c2f5da", color: "#178c4e", fontWeight: "600" }} label={t("APPROVED")} />
											)
										) : (
											<Chip size="normal" label={props.product.status} />
										)} */}
                    <Chip
                      size="normal"
                      // style={{ background: "#c2f5da", color: "#178c4e", fontWeight: "600" }}
                      className={
                        props.product.status &&
                          props.product.status === "P_PUBLISHED"
                          ? "successChip"
                          : props.product.status &&
                            props.product.status === "P_REJECTED"
                            ? "errorChip"
                            : "inProgressChip"
                      }
                      label={
                        props.product.statusDisplayName &&
                          props.product.statusDisplayName != ""
                          ? props.product.statusDisplayName
                          : "In Draft"
                      }
                    ></Chip>
                  </div>
                </div>
              </div>
              <CardContent style={{ marginTop: "0px", marginBottom: "10px" }}>
                <div className={classes.productTitle}>
                  {props.solutionAction === "/product" ||
                    props.solutionAction === "/newOrder" ||
                    props.solutionAction === "/myOfferings"
                    ? props.product.name
                    : props.product.productName}
                </div>
                <div className={classes.productDescription}>
                  {props.solutionAction === "/product" ||
                    props.solutionAction === "/newOrder" ||
                    props.solutionAction === "/myOfferings"
                    ? props.product.description
                    : props.product.productDescription}
                </div>
                <div className={classes.priceGroup}>
                  {props.product.isBundle && (
                    <span className={classes.catalogSmallText}>
                      {t("STARTING_FROM_TEXT")}
                    </span>
                  )}
                  <span
                    className={classes.price}
                    style={{ color: props.tenantData.color }}
                  >
                    {props.solutionAction === "/product" ||
                      props.solutionAction === "/newOrder" ||
                      props.solutionAction === "/myOfferings" ? (
                      <>
                        {currencyFormatter(props.product.price.priceAmount)}
                        {props.product.price.priceType === "RC"
                          ? t("PER_MONTH")
                          : ""}
                      </>
                    ) : (
                      <>{currencyFormatter(props.product.startingPrice)}</>
                    )}
                  </span>
                </div>
              </CardContent>
            </Link>
            <CardActions className={classes.cardActionsFlex}>
              {props.solutionAction === "/myOfferings" ? (
                <>
                  {props.menuPaths.includes("/newOrder/:id") &&
                    props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                      <Button
                        style={{ flex: 2 }}
                        onClick={() => {
                          const { product, subscriptionData, offeringCustomer, availableCustomers } = props;
                          navigate(`/newOrder/${product?.productId}`, {
                            state: {
                              subsciptionData: subscriptionData || {},
                              offeringCustomer: product?.isBundle ? "" : offeringCustomer || "",
                              availableCustomers: availableCustomers || [],
                            },
                          });
                        }}

                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "5px",
                              position: "relative",
                              top: ".1rem",
                            }}
                          >
                            <CartIcon />
                          </span>
                          <span style={{ fontSize: "0.8rem" }}>
                            {props.quoteEnabled ? (
                              <>{t("CREATE_QUOTE")}</>
                            ) : (
                              <>{t("PLACE_ORDER")}</>
                            )}
                          </span>
                        </div>
                      </Button>
                    )}

                  {(props.providerType === "SALES_CHNL_PROVIDER" ||
                    props.providerType === "SOLUTION_PROVIDER") &&
                    props.solutionAction === "/myOfferings" &&
                    props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                    props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                      <>
                        {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                          props.userPerms.includes("CATALOG_CREATE") ||
                          props.userPerms.includes("CATALOG_ADMIN")) &&
                          props.product.status !== "P_PUBLISHED" ? (
                          <React.Fragment>
                            {!props.product.sellable ? (
                              <Button
                                style={{ flex: 1 }}
                                // className={classes.button2}
                                className={"buttonSecondary"}
                                onClick={() => {
                                  navigate(
                                    `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                                  );
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span style={{ marginRight: ".5rem" }}>
                                    <svg
                                      width="13"
                                      height="12"
                                      viewBox="0 0 13 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  <span style={{ fontSize: "0.8rem" }}>
                                    {t("EDIT")}
                                  </span>
                                </div>
                              </Button>
                            ) : (
                              <Button
                                style={{ flex: 1 }}
                                // className={classes.button2}
                                className={"buttonSecondary"}
                                onClick={() => {
                                  props.editStandaloneProduct(
                                    props.product.productId,
                                    props.product.productTypeId,
                                  );
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span style={{ marginRight: ".5rem" }}>
                                    <svg
                                      width="13"
                                      height="12"
                                      viewBox="0 0 13 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  <span style={{ fontSize: "0.8rem" }}>
                                    {t("EDIT")}
                                  </span>
                                </div>
                              </Button>
                            )}
                          </React.Fragment>
                        ) : (
                          (props.userPerms.includes("CUMULATOR_CATALOG_VIEW") ||
                            props.userPerms.includes("CATALOG_VIEW")) && (
                            <React.Fragment>
                              {!props.product.sellable ? (
                                <Button
                                  style={{ flex: 1 }}
                                  className={"buttonSecondary"}
                                  onClick={() => {
                                    navigate(
                                      `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=false`,
                                    );
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        marginRight: ".5rem",
                                      }}
                                    >
                                      <ViewIconNew />
                                    </span>
                                    <span style={{ fontSize: "0.8rem" }}>
                                      {t("VIEW")}
                                    </span>
                                  </div>
                                </Button>
                              ) : (
                                <Button
                                  style={{ flex: 1 }}
                                  className={"buttonSecondary"}
                                  onClick={() => {
                                    props.editStandaloneProduct(
                                      props.product.productId,
                                      props.product.productTypeId,
                                    );
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        marginRight: ".5rem",
                                      }}
                                    >
                                      <ViewIconNew />
                                    </span>
                                    <span style={{ fontSize: "0.8rem" }}>
                                      {t("VIEW")}
                                    </span>
                                  </div>
                                </Button>
                              )}
                            </React.Fragment>
                          )
                        )}
                      </>
                    )}
                  <div>
                    {(props.providerType === "SALES_CHNL_PROVIDER" ||
                      props.providerType === "SOLUTION_PROVIDER") &&
                      props.solutionAction === "/myOfferings" &&
                      props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                      props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                        <>
                          {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                            props.userPerms.includes("CATALOG_CREATE") ||
                            props.userPerms.includes("CATALOG_ADMIN")) && (
                              <React.Fragment>
                                {props.product.isBundle && (
                                  <>
                                    <Button
                                      style={{ padding: "2px 8px" }}
                                      className="buttonSecondary"
                                      aria-describedby={id}
                                      type="button"
                                      onClick={handleClick}
                                    >
                                      ...
                                    </Button>
                                    <Popper
                                      id={id}
                                      open={open}
                                      anchorEl={anchorEl}
                                      placement="bottom-start"
                                      modifiers={[
                                        {
                                          name: "offset",
                                          options: { offset: [0, 8] }, // new format
                                        },
                                      ]}
                                    >
                                      <ClickAwayListener
                                        onClickAway={handleClose}
                                      >
                                        <Paper>
                                          <MenuList
                                            autoFocusItem={open}
                                            id="menu-list-grow"
                                          >
                                            {!props.tenantRoles.includes(
                                              "CHILD_PROVIDER",
                                            ) && (
                                                <MenuItem
                                                  onClick={handlePushOffering}
                                                >
                                                  <span
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <ExportIcon />
                                                  </span>
                                                  <span
                                                    style={{ fontSize: ".8rem" }}
                                                  >
                                                    {t("PUSH_OFFERING")}
                                                  </span>
                                                </MenuItem>
                                              )}
                                            <MenuItem
                                              onClick={() => {
                                                navigate(
                                                  `/createSpecialPrice?packageId=${props.product.productId}&packageMode=promo`,
                                                );
                                              }}
                                            >
                                              <span
                                                style={{
                                                  marginRight: ".5rem",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <EditSpecialPrice />
                                              </span>
                                              <span style={{ fontSize: ".8rem" }}>
                                                {t("EDIT_SPECIAL_PRICING")}
                                              </span>
                                            </MenuItem>
                                            <MenuItem
                                              onClick={() => {
                                                props.removeProduct(
                                                  props.product.productId,
                                                  props.productIndex,
                                                );
                                              }}
                                            >
                                              <span
                                                style={{
                                                  marginRight: ".5rem",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <DeleteIconNew />
                                              </span>
                                              <span style={{ fontSize: ".8rem" }}>
                                                {t("DELETE")}
                                              </span>
                                            </MenuItem>
                                          </MenuList>
                                        </Paper>
                                      </ClickAwayListener>
                                    </Popper>
                                  </>
                                )}
                              </React.Fragment>
                            )}
                        </>
                      )}
                  </div>
                </>
              ) : (
                <React.Fragment>
                  <Tooltip title={t("ADD_TO_MY_SOLUTIONS")}>
                    {props.product.offeringProvider == "MASTER_PROVIDER" ? (
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          navigate(
                            `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=true&isMaster=true`,
                          );
                        }}
                      >
                        <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
                        <path
                          d="M17 10.8571H11.8571V16H10.1429V10.8571H5V9.14286H10.1429V4H11.8571V9.14286H17V10.8571Z"
                          fill={props.tenantData.color}
                        />
                      </svg>
                    ) : (
                      <Button
                        style={{ flex: 1 }}
                        className={classes.button1}
                        onClick={() => {
                          navigate(
                            `/updatePackage?packageId=${props.product.productId}&packageMode=edit&addToCatalog=true&isMaster=false`,
                          );
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span style={{ marginRight: ".5rem" }}>
                            <svg
                              width="16"
                              height="16"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                              fill="currentColor"
                            >
                              <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                            </svg>
                          </span>
                          {t("ADD_TO_MY_SOLUTIONS")}
                        </div>
                      </Button>
                    )}
                  </Tooltip>
                </React.Fragment>
              )}
            </CardActions>
          </>
        ) : (
          <>
            <Link
              to={
                props.publicBrowsing
                  ? `/viewSolution/${props.product.productOfferingId}`
                  : `${location.pathname}/${props.product.productOfferingId}`
              }
              state={
                props.publicBrowsing
                  ? undefined
                  : props.providerType === "SOLUTION_PROVIDER" &&
                    (location.pathname === "/newOrder" || location.pathname === "/product")
                    ? {
                      subsciptionData: props.subsciptionData || {},
                      offeringCustomer: props.offeringCustomer,
                      parentTenantId: props.tenantId,
                      availableCustomers: props.availableCustomers || [],
                    }
                    : {
                      subsciptionData: props.subsciptionData || {},
                      offeringCustomer: props.offeringCustomer,
                      availableCustomers: props.availableCustomers || [],
                      isLeadQuote: props.isLeadQuote || false,
                      leadData: props.leadData || {},
                    }
              }
            >
              <div className={classes.imageContainer}>
                <div className={classes.imageWrapper}>
                  {/* <CardMedia
									component="img"
									alt={props.product.name}
									height="140"
									image={props.product.largeImageUrl ? constants.imageUrl + props.product.largeImageUrl : placeholderImage}
									title={props.product.name}
									onError={DefaultImage}
									className={classes.cardImageNew}
								/> */}
                  <div
                    className="product-card-image-wrapper"
                    style={{
                      backgroundImage: props.product.largeImageUrl
                        ? `url(${constants.imageUrl + props.product.largeImageUrl})`
                        : `url(${placeholderImage})`,
                    }}
                  >
                    {/* <img src={props.product.largeImageUrl ? constants.imageUrl + props.product.largeImageUrl : placeholderImage}
											alt={props.product.name}
										/> */}
                  </div>
                  <div className={classes.chipWrapper}>
                    <Chip
                      size="normal"
                      className={
                        props.product.status &&
                          props.product.status === "P_PUBLISHED"
                          ? "successChip"
                          : props.product.status &&
                            props.product.status === "P_REJECTED"
                            ? "errorChip"
                            : "inProgressChip"
                      }
                      label={
                        props.product.statusDisplayName &&
                          props.product.statusDisplayName != ""
                          ? props.product.statusDisplayName
                          : "In Draft"
                      }
                    ></Chip>
                  </div>
                </div>
              </div>
              <CardContent style={{ marginTop: "0px", marginBottom: "10px" }}>
                <div className={classes.productTitle}>
                  {props.solutionAction === "/product" ||
                    props.solutionAction === "/newOrder"
                    ? props.product.name
                    : props.product.productName}
                </div>
                <div className={classes.productDescription}>
                  {props.solutionAction === "/product" ||
                    props.solutionAction === "/newOrder" ||
                    props.solutionAction === "/myOfferings"
                    ? props.product.description
                    : props.product.productDescription}
                </div>
                {(props.providerType === "SALES_CHNL_PROVIDER" ||
                  props.publicBrowsing) && (
                    <div className={classes.priceGroup}>
                      {props.product.isBundle && (
                        <span className={classes.catalogSmallText}>
                          {t("STARTING_FROM_TEXT")}
                        </span>
                      )}
                      <span
                        className={classes.price}
                        style={{ color: props.tenantData.color }}
                      >
                        {props.solutionAction === "/product" ||
                          props.solutionAction === "/newOrder" ? (
                          <>
                            {currencyFormatter(props.product.price.priceAmount)}
                            {props.product.price.priceType === "RC"
                              ? t("PER_MONTH")
                              : ""}
                          </>
                        ) : (
                          <>{currencyFormatter(props.product.startingPrice)}</>
                        )}
                      </span>
                    </div>
                  )}
              </CardContent>
            </Link>
            <CardActions className={classes.cardActionsFlex}>
              {props.providerType === "SALES_CHNL_PROVIDER" ||
                props.publicBrowsing ? (
                <>
                  {props.menuPaths.includes("/newOrder/:id") &&
                    props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                      <Button
                        style={{ flex: 1 }}
                        onClick={() => {
                          navigate(`/newOrder/${props.product.productOfferingId}`, {
                            state: {
                              subsciptionData: props.subsciptionData || {},
                              offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                              availableCustomers: props.availableCustomers || [],
                              isLeadQuote: props.isLeadQuote || false,
                              leadData: props.leadData || {},
                            },
                          });
                        }}

                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "5px",
                              position: "relative",
                              top: ".1rem",
                            }}
                          >
                            <CartIcon />
                          </span>
                          <span style={{ fontSize: "0.8rem" }}>
                            {props.quoteEnabled ? (
                              <>{t("CREATE_QUOTE")}</>
                            ) : (
                              <>{t("PLACE_ORDER")}</>
                            )}
                          </span>
                        </div>
                      </Button>
                    )}
                </>
              ) : // <Button>View</Button>
                props.providerType === "SOLUTION_PROVIDER" &&
                  (location.pathname === "/newOrder" ||
                    location.pathname === "/product") &&
                  props.menuPaths.includes("/newOrder/:id") &&
                  props.userPerms.includes("ORDERMGR_SALES_CREATE") ? (
                  <>
                    <Button
                      style={{ flex: 1 }}
                      onClick={() => {
                        navigate(`/newOrder/${props.product.productOfferingId}`, {
                          state: {
                            subsciptionData: props.subsciptionData || {},
                            offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                            availableCustomers: props.availableCustomers || [],
                          },
                        });
                      }}

                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            marginRight: "5px",
                            position: "relative",
                            top: ".1rem",
                          }}
                        >
                          <CartIcon />
                        </span>
                        <span style={{ fontSize: "0.8rem" }}>
                          {props.quoteEnabled ? (
                            <>{t("CREATE_QUOTE")}</>
                          ) : (
                            <>{t("PLACE_ORDER")}</>
                          )}
                        </span>
                      </div>
                    </Button>
                  </>
                ) : (
                  <Link
                    to={
                      props.publicBrowsing
                        ? `/viewSolution/${props.product.productOfferingId}`
                        : `${location.pathname}/${props.product.productOfferingId}`
                    }
                    state={
                      !props.publicBrowsing &&
                        props.providerType === "SOLUTION_PROVIDER" &&
                        location.pathname === "/newOrder"
                        ? {
                          subsciptionData: props.subscriptionData || {}, // fixed typo
                          offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                          parentTenantId: props.tenantId,
                          availableCustomers: props.availableCustomers || [],
                        }
                        : !props.publicBrowsing
                          ? {
                            subsciptionData: props.subscriptionData || {},
                            offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                            availableCustomers: props.availableCustomers || [],
                          }
                          : undefined
                    }
                  >
                    <Tooltip title={t("VIEW")}>
                      <IconButton
                        color="primary"
                        aria-label="View"
                        component="span"
                        // className={classes.cardIconButton}
                        className="buttonSecondary"
                        style={{ color: props.tenantData.color }}
                      >
                        <ViewIconNew />
                        {/* <VisibilityIcon className={classes.cardIcon} /> */}
                      </IconButton>
                    </Tooltip>
                  </Link>
                )}
            </CardActions>
          </>
        )}
      </Card>
      <Dialog
        open={pushOfferingDialog}
        onClose={() => setPushOfferingDialog(false)}
        PaperComponent={DraggableDialogPaper}
        aria-labelledby="draggableDialogPaper"
        fullWidth={true}
        maxWidth={"sm"}
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          {t("PUSH_OFFERING_TO")}
        </DialogTitle>

        <DialogContent dividers>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <Loader loading={true} />
            </div>
          ) : childTenantsList.length > 0 ? (
            <>
              <div
                className="borderOutline roundCorners"
                style={{ display: "flex", flexDirection: "column" }}
              >
                {childTenantsList.map((tenant) => (
                  <FormControlLabel
                    key={tenant.tenantId}
                    control={
                      <Checkbox
                        checked={selectedTenants.includes(tenant.tenantId)}
                        onChange={() => handleTenantSelection(tenant.tenantId)}
                        color="primary"
                      />
                    }
                    label={tenant.tenantName}
                  />
                ))}
              </div>
            </>
          ) : (
            <DialogContentText>{t("NO_CHILD_TENANTS_FOUND")}</DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="buttonSecondary"
            onClick={() => {
              setPushOfferingDialog(false);
              setSelectedTenants([]);
            }}
          >
            {t("CANCEL")}
          </Button>
          <Button
            disabled={selectedTenants.length === 0}
            onClick={() => {
              pushOfferingToTenants(selectedTenants);
            }}
          >
            {t("PUSH")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Loader isLoading={isLoading} /> */}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    publicBrowsing: state.auth.publicBrowsing,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
    quoteEnabled: state.auth.quoteEnabled,
    tenantRoles: state.auth.tenantRoles,
  };
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ProductCardNew),
);
